var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90853 11.0908H1.80173C1.35918 11.0908 1 10.7316 1 10.289V1.80189C1 1.35853 1.35918 1.00015 1.80173 1.00015H7.90853C8.35109 1.00015 8.71027 1.35853 8.71027 1.80189V10.289C8.71027 10.7316 8.35109 11.0908 7.90853 11.0908Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.198 19H12.0912C11.6487 19 11.2895 18.6409 11.2895 18.1983V9.71116C11.2895 9.2678 11.6487 8.90942 12.0912 8.90942H18.198C18.6414 8.90942 18.9998 9.2678 18.9998 9.71116V18.1983C18.9998 18.6409 18.6414 19 18.198 19Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.198 6.37081H12.0912C11.6487 6.37081 11.2895 6.01163 11.2895 5.56908V1.80173C11.2895 1.35918 11.6487 1 12.0912 1H18.198C18.6414 1 18.9998 1.35918 18.9998 1.80173V5.56908C18.9998 6.01163 18.6414 6.37081 18.198 6.37081Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90853 19.0001H1.80173C1.35918 19.0001 1 18.6409 1 18.1983V14.431C1 13.9884 1.35918 13.6292 1.80173 13.6292H7.90853C8.35109 13.6292 8.71027 13.9884 8.71027 14.431V18.1983C8.71027 18.6409 8.35109 19.0001 7.90853 19.0001Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardicon);
export default __webpack_public_path__ + "static/media/dashboardicon.64c145831a499da00e6690b39066bb58.svg";
export { ForwardRef as ReactComponent };